import  {type MatrixClient} from 'matrix-js-sdk'

let cachedConfig: {['m.upload.size']?: number} | null = null

/**
 * Fetch and cache the homeserver's media config (upload size limit).
 * Clears cache on 413 errors so limits are re-fetched.
 */
export async function getMediaConfig(
  client: MatrixClient,
): Promise<{maxUploadSize?: number}> {
  if (cachedConfig) {
    return {maxUploadSize: cachedConfig['m.upload.size']}
  }
  try {
    cachedConfig = await client.getMediaConfig()
    return {maxUploadSize: cachedConfig?.['m.upload.size']}
  } catch {
    return {maxUploadSize: undefined}
  }
}

/**
 * Clear the cached config. Call this on HTTP 413 responses.
 */
export function clearMediaConfigCache(): void {
  cachedConfig = null
}

/**
 * Check if a file size is within the homeserver's upload limit.
 * Returns true if acceptable (or if no limit is known).
 */
export function isFileSizeAcceptable(
  fileSize: number,
  maxUploadSize: number | undefined,
): boolean {
  if (maxUploadSize === undefined) return true
  return fileSize <= maxUploadSize
}

/**
 * Format bytes into a human-readable string.
 */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 * 1024 * 1024)
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`
}
